import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import { Reveal, ScaleImage } from "@/components/site/Reveal";
import { POSTS } from "@/data/blog";

export default function Blog() {
  const [featured, ...rest] = POSTS;

  return (
    <div data-testid="blog-page">
      <PageHero
        index="/ 05"
        overline="Journal"
        title={<>Insights on precision<br />& manufacturing.</>}
        subtitle="Perspectives on tolerance, materials science and manufacturing practice for defence, marine and heavy engineering."
      />

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12">
          {featured && (
            <Reveal>
              <Link
                to={`/blog/${featured.slug}`}
                data-testid="blog-featured"
                className="group grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center mb-20 pb-12 border-b border-border"
              >
                <div className="lg:col-span-7">
                  <ScaleImage src={featured.cover} alt={featured.title} className="h-[300px] md:h-[460px]" />
                </div>
                <div className="lg:col-span-5">
                  <div className="flex items-center gap-4 mb-6 font-mono-tech text-[11px] uppercase tracking-widest text-muted-foreground">
                    <span className="text-[hsl(var(--signal))]">{featured.category}</span>
                    <span>{featured.date}</span>
                    <span>{featured.readTime}</span>
                  </div>
                  <h2 className="font-display font-medium text-3xl md:text-5xl tracking-tight leading-[1.05] group-hover:text-muted-foreground transition-colors">
                    {featured.title}
                  </h2>
                  <p className="mt-6 text-muted-foreground leading-relaxed">{featured.excerpt}</p>
                  <span className="mt-8 inline-flex items-center gap-2 font-mono-tech text-[12px] uppercase tracking-widest">
                    Read Article
                    <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </Reveal>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {rest.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
                  <ScaleImage src={p.cover} alt={p.title} className="h-64" />
                  <div className="flex items-center gap-3 mt-5 font-mono-tech text-[10px] uppercase tracking-widest text-muted-foreground">
                    <span className="text-[hsl(var(--signal))]">{p.category}</span>
                    <span>{p.readTime}</span>
                  </div>
                  <h3 className="mt-3 font-display font-medium text-2xl tracking-tight leading-[1.15] group-hover:text-muted-foreground transition-colors">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed line-clamp-3">{p.excerpt}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
